import { createReducer, createFeature, on } from '@ngrx/store';
import { DateOfStay } from '../../../objects/date-of-stay';
import {
  setDateOfStay,
} from '../actions/date-of-stay.actions';

export interface State {
  dateOfStay: DateOfStay | null;
}

export const initialState: State = {
  dateOfStay: null,
};

export const dateOfStayFeature = createFeature({
  name: 'dateOfStay',
  reducer: createReducer(
    initialState,
    on(setDateOfStay, (state, { dateOfStay }) => ({
      dateOfStay,
    })),
  ),
});

export const {
  name: dateOfStayFeatureKey,
  reducer,
  selectDateOfStayState,
  selectDateOfStay,
} = dateOfStayFeature;
